import { testDeepDiffMapper } from '../../engine/deepDiffMapper'
import { settings } from '../../engine/settings-sidecar'
import { common } from '../../main/common-sidecar'
import { spritesUtil } from '../../sprites/spritesUtil-sidecar'
import { uiFps } from '../../ui/uiFps-sidecar'
import { clickEater } from '../../uiParts/clickEater-sidecar'
import { voyageBackground } from './voyageBackground-sidecar'
import { voyageGameManager } from './voyageGameManager-sidecar'
import { voyageKeyboard } from './voyageKeyboard-sidecar'
import { voyageLayers } from './voyageLayers-sidecar'
import { voyageParticlesData } from './voyageParticlesData-sidecar'
import { voyageSaver } from './voyageSaver-sidecar'
import { voyageSounds } from './voyageSounds-sidecar'
import { voyageSystemsData } from './voyageSystemsData-sidecar'
import { voyageTestParams } from './voyageTestParams-sidecar'
import { voyageTileData } from './voyageTileData-sidecar'
import { voyageTilemap } from './voyageTilemap-sidecar'

export function create() {
  spritesUtil.setDefaultScale(2)
  settings.create('voyage:settings', 1)

  voyageParticlesData.registerAll()
  voyageTileData.registerAll()
  voyageSystemsData.registerAll()

  const soundsJson = common.getPhaserScene().cache.json.get('audioSprite2')
  voyageSounds.load(soundsJson, '/assets/music')

  voyageLayers.create()

  // buttons2.setDefaultFrames(buttons2.defaultFramesBasic)
  // buttons2.setDefaultFont(echoFonts.getData().font6)

  uiFps.create(voyageLayers.getLayers().uiGame)
  uiFps.setOpen(true)
  clickEater.create()
  voyageKeyboard.create()

  voyageTilemap.create()
  voyageSaver.load()

  voyageBackground.create()

  if (!voyageTestParams.isDevMode) {
    voyageGameManager.goMenuMain()
  } else {
    let tm = voyageTestParams.loadTestMode()
    if (tm === 'editor') {
      voyageGameManager.goEditor()
    } else if (tm === 'game') {
      voyageGameManager.goGame()
    } else {
      // do menu
      voyageGameManager.goMenuMain()
    }
  }
}
